import { DisplayText } from './displayText';
import { EventColumn } from './eventsColumn';

export class EventsActionColumns {
    fullColumnList: EventColumn[];
    displayedColumnList: EventColumn[];

    constructor() {
        this.fullColumnList = [];
        this.displayedColumnList = [];
    }

    getHiddenColumnList() {
        return this.fullColumnList.filter(x => !this.displayedColumnList.includes(x));
    }

    addDisplayedColumnList(key: string) {
        const element =  this.displayedColumnList.find( (e) => e.column.key === key);
        if (!element) {
            const elementToAdd =  this.fullColumnList.find( (e) => e.column.key === key);
            if (elementToAdd) {
                this.displayedColumnList.push(elementToAdd);
            }
        }
    }

    removeDisplayedColumnList(key: string) {
        const element =  this.displayedColumnList.find( (e) => e.column.key === key);
        if (element) {
            const newElements = this.displayedColumnList.filter((e) => e.column.key !== key);
            this.displayedColumnList = newElements;
        }
    }

    allColumnAreDisplayed() {
        return (this.displayedColumnList.length === this.fullColumnList.length) ? true : false;
    }

    columnDisplayedAreDefault(): boolean {
        const element = this.displayedColumnList.find((e) => e.isDefault === false);
        if (element) {
            return false;
        }

        const fullList = this.fullColumnList.filter((e) => e.isDefault === true);
        const displayedList = this.displayedColumnList.filter((e) => e.isDefault === true);
        if (fullList.length > 0 && displayedList.length > 0 && fullList.length === this.displayedColumnList.length) {
            return true;
        }
        return false;
    }
}
